import { pxToRem } from '../utils';

export const type = {
  '88_medium': {
    fontSize: pxToRem(88),
    fontWeight: 500,
    lineHeight: pxToRem(96.8), // 110%
    letterSpacing: pxToRem(-1.76),
  },
  '72_medium': {
    fontSize: pxToRem(72),
    fontWeight: 500,
    lineHeight: pxToRem(72), // 100%
    letterSpacing: pxToRem(-1.44),
  },
  '64_medium': {
    fontSize: pxToRem(64),
    fontWeight: 500,
    lineHeight: pxToRem(70.4), // 110%
    letterSpacing: pxToRem(-1.28),
  },
  '56_medium': {
    fontSize: pxToRem(56),
    fontWeight: 500,
    lineHeight: pxToRem(61.6), // 110%
    letterSpacing: pxToRem(-1.12),
  },
  '44_regular': {
    fontSize: pxToRem(44),
    fontWeight: 400,
    lineHeight: pxToRem(52.8), // 120%
    letterSpacing: pxToRem(-0.88),
  },
  '44_medium': {
    fontSize: pxToRem(44),
    fontWeight: 500,
    lineHeight: pxToRem(48.4), // 110%
    letterSpacing: pxToRem(-0.88),
  },
  '40_regular': {
    fontSize: pxToRem(40),
    fontWeight: 400,
    lineHeight: pxToRem(48), // 120%
    letterSpacing: pxToRem(-0.8),
  },
  '40_medium': {
    fontSize: pxToRem(40),
    fontWeight: 500,
    lineHeight: pxToRem(44), // 110%
    letterSpacing: pxToRem(-0.8),
  },
  '32_regular': {
    fontSize: pxToRem(32),
    fontWeight: 400,
    lineHeight: pxToRem(36), // 110%
    letterSpacing: pxToRem(-0.64),
  },
  '32_medium': {
    fontSize: pxToRem(32),
    fontWeight: 500,
    lineHeight: pxToRem(35.2), // 110%
    letterSpacing: pxToRem(-0.64),
  },
  '28_medium': {
    fontSize: pxToRem(28),
    fontWeight: 500,
    lineHeight: pxToRem(30.8), // 110%
    letterSpacing: pxToRem(-0.56),
  },
  '28_medium-hyperlink': {
    fontWeight: 500,
    fontSize: pxToRem(28),
    lineHeight: pxToRem(36.4), // 130%
    letterSpacing: pxToRem(-0.56),
    textDecoration: 'underline',
  },
  '24_regular': {
    fontSize: pxToRem(24),
    fontWeight: 400,
    lineHeight: pxToRem(31.2), // 130%
    letterSpacing: pxToRem(-0.48),
  },
  '24_medium': {
    fontSize: pxToRem(24),
    fontWeight: 500,
    lineHeight: pxToRem(26.4), // 110%
    letterSpacing: pxToRem(-0.48),
  },
  '24_medium-hyperlink': {
    fontWeight: 500,
    fontSize: pxToRem(24),
    lineHeight: pxToRem(31.2), // 130%
    letterSpacing: pxToRem(-0.48),
    textDecoration: 'underline',
  },
  '20_regular': {
    fontSize: pxToRem(20),
    fontWeight: 400,
    lineHeight: pxToRem(26), // 130%
    letterSpacing: pxToRem(-0.4),
  },
  '20_medium': {
    fontSize: pxToRem(20),
    fontWeight: 500,
    lineHeight: pxToRem(24), // 120%
    letterSpacing: pxToRem(-0.4),
  },
  '20_medium-hyperlink': {
    fontWeight: 500,
    fontSize: pxToRem(20),
    lineHeight: pxToRem(26), // 130%
    letterSpacing: pxToRem(-0.4),
    textDecoration: 'underline',
  },
  '18_regular': {
    fontSize: pxToRem(18),
    fontWeight: 400,
    lineHeight: pxToRem(25.2), // 140%
    letterSpacing: pxToRem(-0.36),
  },
  '18_medium': {
    fontSize: pxToRem(18),
    fontWeight: 500,
    lineHeight: pxToRem(21.6), // 120%
    letterSpacing: pxToRem(-0.36),
  },
  '18_medium-hyperlink': {
    fontWeight: 500,
    fontSize: pxToRem(18),
    lineHeight: pxToRem(23.4), // 130%
    letterSpacing: pxToRem(-0.36),
    textDecoration: 'underline',
  },
  '16_regular': {
    fontSize: pxToRem(16),
    fontWeight: 400,
    lineHeight: pxToRem(22.4), // 140%
    letterSpacing: pxToRem(-0.32),
  },
  '16_medium': {
    fontSize: pxToRem(16),
    fontWeight: 500,
    lineHeight: pxToRem(19.2), // 120%
    letterSpacing: pxToRem(-0.32),
  },
  '16_semibold': {
    fontSize: pxToRem(16),
    fontWeight: 600,
    lineHeight: pxToRem(19.2), // 120%
    letterSpacing: pxToRem(-0.32),
  },
  '16_medium-hyperlink': {
    fontWeight: 500,
    fontSize: pxToRem(16),
    lineHeight: pxToRem(20.8), // 130%
    letterSpacing: pxToRem(-0.32),
    textDecoration: 'underline',
  },
  '14_regular': {
    fontSize: pxToRem(14),
    fontWeight: 400,
    lineHeight: pxToRem(19.6), // 140%
    letterSpacing: pxToRem(-0.28),
  },
  '14_medium': {
    fontSize: pxToRem(14),
    fontWeight: 500,
    lineHeight: pxToRem(16.8), // 120%
    letterSpacing: pxToRem(-0.28),
  },
  '14_medium-hyperlink': {
    fontWeight: 500,
    fontSize: pxToRem(14),
    lineHeight: pxToRem(18.2), // 130%
    letterSpacing: pxToRem(-0.28),
    textDecoration: 'underline',
  },
  '12_regular': {
    fontSize: pxToRem(12),
    fontWeight: 400,
    lineHeight: pxToRem(16.8), // 140%
    letterSpacing: pxToRem(0),
  },
  '12_footnote': {
    fontSize: pxToRem(12),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: pxToRem(16.8), // 140%
    letterSpacing: pxToRem(-0.2),
  },
  '12_medium-hyperlink': {
    fontWeight: 500,
    fontSize: pxToRem(12),
    lineHeight: pxToRem(14.4), // 120%
    letterSpacing: pxToRem(-0.24),
    textDecoration: 'underline',
  },
  '12_semibold': {
    fontWeight: 600,
    fontSize: pxToRem(12),
    lineHeight: pxToRem(16.8), // 140%
    letterSpacing: pxToRem(0.56),
  },
  '12_chip': {
    fontWeight: 500,
    fontSize: pxToRem(12),
    letterSpacing: pxToRem(-0.24),
    lineHeight: pxToRem(14.4),
  },
  '10_semibold': {
    fontWeight: 600,
    fontSize: pxToRem(10),
    lineHeight: pxToRem(12),
    letterSpacing: pxToRem(0.4),
  },
};

export type Type = keyof typeof type;
